import { StyleDeclarationValue, css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { NavLink, RouteComponentProps } from 'react-router-dom';
import { IActiveUseDailySummaryByAccount } from '../../../../models/AdminModels';
import { styleSheet } from './styles';

interface IProps extends RouteComponentProps<any> {
	account: IActiveUseDailySummaryByAccount;
	className?: string;
	styles?: StyleDeclarationValue[];
}

class _ReportRowAccountChange extends React.Component<IProps> {
	public render() {
		const { className, styles, account } = this.props;
		let colorClass: object;
		if (account?.usage?.statusColor) {
			const color = account.usage.statusColor.toLocaleLowerCase();
			switch (color) {
				case 'green':
					colorClass = styleSheet.green;
					break;
				case 'yellow':
					colorClass = styleSheet.yellow;
					break;
				case 'orange':
					colorClass = styleSheet.orange;
					break;
				case 'red':
					colorClass = styleSheet.red;
					break;
				default:
					break;
			}
		}

		return (
			<div className={`${css(styleSheet.container, ...(styles || []))} report-row-account-change ${className || ''}`}>
				<NavLink to={'/accounts/' + account.accountId} className={css(styleSheet.company)}>
					{account?.companyName || ''}
				</NavLink>
				<div className={css(styleSheet.csm)}>{account.customerSuccessName}</div>
				<div className={css(styleSheet.status)}>
					<span className={css(styleSheet.statusColor, colorClass)}>
						{account?.usage?.statusColor.toString() || 'Unknown'}
					</span>
					<span>
						{account?.previousStatusColor ? ' (previously ' + account.previousStatusColor.toString() + ')' : ''}
					</span>
				</div>
			</div>
		);
	}
}

const ReportRowAccountChangeAsObserver = observer(_ReportRowAccountChange);
export const ReportRowAccountChange = withRouter(ReportRowAccountChangeAsObserver);
